import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import { CheckIn } from "app/common/Model/CheckIn";
import {
  PAGESIZE_ALL,
  PAYMENT_METHOD_CHARACTERISTIC,
  TYPE_CARD,
} from "app/common/LocalConst";
import { RegisterCard } from "app/common/Model/RegisterCard";
import {
  getTreatmentPlanCardById,
  pagingTreatmentPlanCard,
  removeTreatmentPlanCard,
  saveOrEditTreatmentPlanCard,
} from "app/services/TreatmentPlanCardService";
import { getCurrentStaff } from "app/common/LocalFunction";
import { pagingObj } from "app/services/PatientMethod";

export default class TreatmentPlanListStore {
  searchRegisterTreatmentPlan = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    type: TYPE_CARD[1].value,
  };

  pageRegisterTreatmentPlan = new PageResponse();
  openCreateOrEditTreatmentPlanPopup = false;
  initRegisterTreatmentPlan = { ...new RegisterCard() };
  openConfirmDelete = null;
  openConfirmMessage = null;
  listPaymentMethod = [];
  initialDeposit = null;

  constructor() {
    makeAutoObservable(this);
  }

  pagingRegisterTreatmentPlan = async () => {
    let { departmentId, clientCardId, ...ortherData } =
      this.searchRegisterTreatmentPlan;
    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }
    if (clientCardId) {
      ortherData.clientCardId = clientCardId?.id;
    }

    return await pagingTreatmentPlanCard({ ...ortherData, getServices: true })
      .then(({ data }) => {
        this.pageRegisterTreatmentPlan = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu thẻ liệu trình khách hàng có lỗi");
      });
  };

  saveOrUpdateRegisterService = async (values) => {
    return await saveOrEditTreatmentPlanCard(values)
      .then(({ data }) => {
        this.openCreateOrEditTreatmentPlanPopup = false;
        if (data?.responseStatus === false) {
          setTimeout(() => {
            this.openConfirmMessage = data?.responseDetail;
          }, 500);
          return;
        } else {
          toast.success("Đăng ký thẻ liệu trình thành công");
          this.pagingRegisterTreatmentPlan();
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin đăng ký thẻ liệu trình có lỗi");
      });
  };

  handleChangeFormSearchTreatmentPlan = (searchRegisterTreatmentPlan) => {
    this.searchRegisterTreatmentPlan = {
      ...this.searchRegisterTreatmentPlan,
      ...searchRegisterTreatmentPlan,
    };
    this.pagingRegisterTreatmentPlan();
  };

  handleOpenCreateOrEditTreatmentPlanPopup = async (cardRegister) => {
    if (Boolean(cardRegister)) {
      getTreatmentPlanCardById(cardRegister?.id).then(({ data }) => {
        if (data?.vatPercent) data.vatPercent = data?.vatPercent?.toString();
        data.totalAmount = data?.price;
        this.initRegisterTreatmentPlan = data;
        this.openCreateOrEditTreatmentPlanPopup = true;
      });
    } else {
      this.initRegisterTreatmentPlan = { ...new RegisterCard() };
      this.openCreateOrEditTreatmentPlanPopup = true;
    }
  };

  handleCloseCreateOrEditServicePopup = () => {
    this.openCreateOrEditTreatmentPlanPopup = false;
    this.initRegisterTreatmentPlan = { ...new RegisterCard() };
  };

  handleOpenConfirmDelete = (id) => {
    this.openConfirmDelete = id;
  };

  handleDeleteTreatmentPlanCard = async () => {
    return await removeTreatmentPlanCard(this.openConfirmDelete)
      .then(({ data }) => {
        this.openConfirmDelete = null;
        if (data?.responseStatus === false) {
          toast.error(data?.responseDetail);
        } else {
          toast.success("Xóa thẻ liệu trình thành công");
          this.pagingRegisterTreatmentPlan();
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Xóa thẻ liệu trình có lỗi");
      });
  };

  handleCloseConfirmMessage = () => {
    this.openConfirmMessage = null;
  };

  handleCloseConfirmDialog = () => {
    this.openConfirmDelete = false;
    this.initialTreatmentPlan = new CheckIn();
  };

  handleInitPaymentVoucherPopup = (patient) => {
    let staffRevenues = [];
    if (patient?.currentConsultant) {
      staffRevenues.push({
        position: patient?.currentConsultant?.position,
        staff: patient?.currentConsultant,
        percentRevenue: 100,
      });
    }
    if (patient?.currentTelesale) {
      staffRevenues.push({
        position: patient?.currentTelesale?.position,
        staff: patient?.currentTelesale,
        percentRevenue: 100,
      });
    }

    let voucherPaymentMethods = []; // setup paymentMethod default money = method bank

    voucherPaymentMethods = this.listPaymentMethod?.map((el) => {
      return {
        paymentMethodValue: el,
        totalOfMethod: 0,
        note: "",
        paymentBank:
          el?.characteristic === PAYMENT_METHOD_CHARACTERISTIC[0].value
            ? this.listStk?.[0]
            : null,
      };
    });
    this.initialDeposit = {
      voucherDate: new Date(),
      accountant: getCurrentStaff(),
      staffRevenues,
      patient,
      voucherPaymentMethods,
    };
  };

  getListPaymentMethod = async () => {
    return await pagingObj({ pageIndex: 1, pageSize: PAGESIZE_ALL })
      .then(({ data }) => {
        this.listPaymentMethod = data?.content;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu hình thức thanh toán có lỗi");
      });
  };

  resetStore = () => {
    this.searchRegisterTreatmentPlan = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
      type: TYPE_CARD[1].value,
    };
    this.pageRegisterTreatmentPlan = new PageResponse();
    this.openCreateOrEditTreatmentPlanPopup = false;
    this.initRegisterTreatmentPlan = { ...new RegisterCard() };
    this.openConfirmMessage = null;
  };
}
